import styled from "styled-components";

const MainContainer = styled.div`
  margin-top: ${(props) => props.marginTop};
  padding-top: ${(props) => props.paddingTop};

  @media screen and (min-width: 36rem) {
    margin-top: ${(props) => props.smMarginTop};
    padding-top: ${(props) => props.smPaddingTop};
  }

  @media screen and (min-width: 48rem) {
    margin-top: ${(props) => props.mdMarginTop};
    padding-top: ${(props) => props.mdPaddingTop};
  }

  @media screen and (min-width: 62rem) {
    margin-top: ${(props) => props.lgMarginTop};
    padding-top: ${(props) => props.lgPaddingTop};
  }

  @media screen and (min-width: 75rem) {
    margin-top: ${(props) => props.xlMarginTop};
    margin-top: ${(props) => props.xlPaddingTop};
  }
`;

export default MainContainer;
